import { render } from "./OcrTableSectionSkeleton.vue?vue&type=template&id=48fb9e8c"
import script from "./OcrTableSectionSkeleton.vue?vue&type=script&lang=js"
export * from "./OcrTableSectionSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__